/**
 * Shared admin utilities: formatting, badges, etc.
 */

const API = `${window.location.origin}/api`;

const formatPrice = (price) =>
  new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price);

const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });

const formatActivityType = (type) => {
  const types = {
    'prestataire_evenementiel': 'Prestataire événementiel',
    'dj': 'DJ', 'etablissement': 'Établissement',
    'particulier': 'Particulier', 'autre': 'Autre'
  };
  return types[type] || type || 'Non renseigné';
};

const getActivityTypeBadgeClass = (type) => {
  const classes = {
    'prestataire_evenementiel': 'bg-purple-500/20 text-purple-400 border-purple-500/30',
    'dj': 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    'etablissement': 'bg-green-500/20 text-green-400 border-green-500/30',
    'particulier': 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    'autre': 'bg-slate-500/20 text-slate-400 border-slate-500/30'
  };
  return classes[type] || 'bg-slate-500/20 text-slate-400 border-slate-500/30';
};

const STATUS_BADGES = {
  confirmed: { color: 'bg-blue-500/20 text-blue-400', text: 'Confirmé' },
  pending: { color: 'bg-yellow-500/20 text-yellow-400', text: 'En attente' },
  pending_validation: { color: 'bg-orange-500/20 text-orange-400', text: 'À valider' },
  cancelled: { color: 'bg-red-500/20 text-red-400', text: 'Annulé' },
  rejected: { color: 'bg-red-500/20 text-red-400', text: 'Refusé' },
  active: { color: 'bg-blue-500/20 text-blue-400', text: 'Actif' },
  shipped: { color: 'bg-green-500/20 text-green-400', text: 'Expédié' },
  delivered: { color: 'bg-emerald-500/20 text-emerald-300', text: 'Livré' },
  completed: { color: 'bg-slate-500/20 text-slate-400', text: 'Terminé' },
  return_pending: { color: 'bg-orange-500/20 text-orange-400', text: 'Retour en cours' },
  returned: { color: 'bg-purple-500/20 text-purple-400', text: 'Retourné' },
  terminated: { color: 'bg-slate-500/20 text-slate-400', text: 'Terminé' }
};

const PAYMENT_STATUS_BADGES = {
  paid: { color: 'bg-green-500/20 text-green-400', text: 'Payé' },
  refunded: { color: 'bg-orange-500/20 text-orange-400', text: 'Remboursé' },
  pending: { color: 'bg-yellow-500/20 text-yellow-400', text: 'En attente' },
  failed: { color: 'bg-red-500/20 text-red-400', text: 'Échoué' }
};

export {
  API,
  formatPrice,
  formatDate,
  formatActivityType,
  getActivityTypeBadgeClass,
  STATUS_BADGES,
  PAYMENT_STATUS_BADGES
};
